import { render } from "./GlobalBanner.vue?vue&type=template&id=69a2647a&scoped=true"
import script from "./GlobalBanner.vue?vue&type=script&lang=js"
export * from "./GlobalBanner.vue?vue&type=script&lang=js"

import "./GlobalBanner.vue?vue&type=style&index=0&id=69a2647a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a2647a"]])

export default __exports__